exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dialog .el-dialog__header[data-v-0d24ab14] {\n  height: 0.229167rem;\n}\n.dialogcontainer[data-v-0d24ab14] {\n  height: 60vh;\n  overflow-y: scroll;\n}\n.tree-node[data-v-0d24ab14] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.tree-node .tree-right[data-v-0d24ab14] {\n  margin-right: 0.104167rem;\n}\n[data-v-0d24ab14] .el-tree-node__content .el-tree-node__expand-icon {\n  display: none;\n}\n[data-v-0d24ab14] .el-tree-node > .el-tree-node__content > .is-disabled {\n  display: none;\n}", ""]);

// exports
